"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _polished = require("polished");

var hoverColor = function hoverColor(hexa) {
  var percent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.1;
  var increase = arguments.length > 2 ? arguments[2] : undefined;
  var isColorLight = (0, _polished.getLuminance)(hexa) > 0.179;
  return isColorLight ? (0, _polished.darken)(percent, hexa) : (0, _polished.lighten)(percent, hexa);
};

var _default = hoverColor;
exports.default = _default;